import React, { useEffect, useState } from "react";
import { Logo } from "./logo";

const links = [
  ["Home", "#header"],
  ["Why Us", "#features"],
  ["Services", "#services"],
  ["Our Work", "#portfolio"],
  ["Team", "#team"],
  ["About", "#about"],
  ["Contact", "#contact"],
];

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItem =
    "px-3 py-2 text-sm font-bold tracking-wide text-slate-300 hover:text-white transition";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-[9999] transition-all duration-300 ${
        scrolled
          ? "bg-[#070b18]/85 backdrop-blur-xl border-b border-white/10 shadow-[0_10px_40px_rgba(0,0,0,0.45)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="px-4">
        <div
          className={`flex items-center justify-between transition-all duration-300 ${
            scrolled ? "h-[66px]" : "h-[76px]"
          }`}
        >
          {/* Logo */}
          <Logo uid="nav" size={scrolled ? 38 : 42} />

          {/* Desktop menu */}
          <div className="hidden lg:flex items-center gap-1">
            {links.map(([label, href]) => (
              <a key={href} href={href} className={navItem}>
                {label}
              </a>
            ))}
            <a
              href="#contact"
              className="ml-3 inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-extrabold text-sm text-white bg-gradient-to-br from-blue-600 to-violet-600 btn-glow hover:-translate-y-0.5 transition"
            >
              Get a Quote →
            </a>
          </div>

          {/* Mobile button */}
          <button
            className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-xl glass-strong text-white"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            <div className="space-y-1.5">
              <span className={`block w-5 h-0.5 bg-white transition ${open ? "translate-y-2 rotate-45" : ""}`} />
              <span className={`block w-5 h-0.5 bg-white transition ${open ? "opacity-0" : ""}`} />
              <span className={`block w-5 h-0.5 bg-white transition ${open ? "-translate-y-2 -rotate-45" : ""}`} />
            </div>
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden pb-4">
            <div className="flex flex-col gap-1 rounded-2xl glass-strong p-3">
              {links.map(([label, href]) => (
                <a
                  key={href}
                  onClick={() => setOpen(false)}
                  href={href}
                  className="px-3 py-2.5 rounded-xl text-sm font-bold text-slate-200 hover:bg-white/5 hover:text-white transition"
                >
                  {label}
                </a>
              ))}
              <a
                onClick={() => setOpen(false)}
                href="#contact"
                className="mt-1 text-center px-4 py-3 rounded-xl font-extrabold text-white bg-gradient-to-br from-blue-600 to-violet-600"
              >
                Get a Quote →
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
